<app-modal-wrapper (cancel)="onCancel()" (save)="onSave()" [options]="options" [isValid]="canSave()">
  <div class="user-editor-container editor-container">
    <form class="user-form admin-form">
      <shared-ui-text-input label="First Name" [control]="form?.firstName"></shared-ui-text-input>
      <shared-ui-text-input label="Last Name" [control]="form?.lastName"></shared-ui-text-input>
      <shared-ui-text-input label="Alias" [control]="form?.alias"></shared-ui-text-input>
      <shared-ui-dropdown label="Company" [control]="form?.companyId" [options]="form!.companyOptions" valueName="id" displayName="name"></shared-ui-dropdown>
      <shared-ui-text-input label="Email" [control]="form?.email"></shared-ui-text-input>
      <shared-ui-checkbox label="Active" [control]="form?.isActive"></shared-ui-checkbox>
    </form>
  </div>
</app-modal-wrapper>
